import ListaSocial from "../componentes/ListaSocial.vue";
import FormSocial from "../componentes/FormSocial.vue";
import ListaSocialCliente from "../componentes/ListaSocialCliente.vue";
import ListaClientesSocial from "../componentes/ListaClientesSocial.vue";
const tipo = 1;
const str = "social";
const routes = [
    ...route("/form-social", FormSocial, {
        Auth: true,
        tipo: tipo,
        str: str,
    }),
    ...route("/lista-social", ListaSocial, {
        Auth: true,
        tipo: tipo,
        str: str,
    }),
    ...route("/lista-clientes-social", ListaClientesSocial, {
        Auth: true,
        tipo: tipo,
        str: str,
    }),
    ...route("/social-cliente", ListaSocialCliente, {
        Auth: false,
        tipo: tipo,
        str: str,
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
